import { defineMessages } from 'react-intl';

const t = defineMessages({
  'shared.navbar.app-title': {
    id: 'shared.navbar.app-title',
    defaultMessage: 'Profile',
  },
  'shared.navbar.my-account': {
    id: 'shared.navbar.my-account',
    defaultMessage: 'My Account',
  },
  'shared.cancel': {
    id: 'shared.cancel',
    defaultMessage: 'Cancel',
  },
  'shared.done': {
    id: 'shared.done',
    defaultMessage: 'Done',
  },
  'shared.save': {
    id: 'shared.save',
    defaultMessage: 'Save',
  },
  'shared.saving': {
    id: 'shared.saving',
    defaultMessage: 'Saving...',
  },
  'shared.edit': {
    id: 'shared.edit',
    defaultMessage: 'Edit',
  },
  'shared.close': {
    id: 'shared.close',
    defaultMessage: 'Close',
  },
  'shared.continue': {
    id: 'shared.continue',
    defaultMessage: 'Continue',
  },
  'shared.none-set': {
    id: 'shared.none-set',
    defaultMessage: 'None set',
  },
  'shared.disabled': {
    id: 'shared.disabled',
    defaultMessage: 'Disabled',
  },
  'shared.enabled': {
    id: 'shared.enabled',
    defaultMessage: 'Enabled',
  },
  'shared.enabled-connected-to-device': {
    id: 'shared.enabled-connected-to-device',
    defaultMessage: 'Enabled, connected to device',
  },
  'shared.illegal-character-entry': {
    id: 'shared.illegal-character-entry',
    defaultMessage: 'Enter a value that doesn\'t include <, >, %, &, or brackets.',
  },
  'shared.back': {
    id: 'shared.back',
    defaultMessage: 'Back',
  },
  'shared.confirm': {
    id: 'shared.confirm',
    defaultMessage: 'Confirm',
  },
  'shared.confirming': {
    id: 'shared.confirming',
    defaultMessage: 'Confirming...',
  },
  'shared.help.support': {
    id: 'shared.help.support',
    defaultMessage: 'Support',
  },
  'shared.email-verification.verification-code': {
    id: 'shared.email-verification.verification-code',
    defaultMessage: 'Verification code'
  },
  'shared.email-verification.info-message': {
    id: 'shared.email-verification.info-message',
    defaultMessage: 'If you don\'t get an email within 5 minutes, check your spam & trash folders. If you don\'t find it, we can '
  },
  'shared.email-verification.user-instruction': {
    id: 'shared.email-verification.user-instruction',
    defaultMessage: 'We just sent a confirmation email to <span>{emailAddress}</span> with a verification code. Please enter it below.'
  },
  'shared.email-verification.resend-verification-email-link-text': {
    id: 'shared.email-verification.resend-verification-email-link-text',
    defaultMessage: 'Resend the email'
  },
  'shared.email-verification.number-entry-validation-failure': {
    id: 'shared.email-verification.number-entry-validation-failure',
    defaultMessage: 'Enter a valid verification code with all numerals (for example, 123456).',
  },
  'shared.email-verification.entry-validation-failure': {
    id: 'shared.email-verification.entry-validation-failure',
    defaultMessage: 'That\'s an invalid verification code. Check your email and try again.',
  },
  'shared.email-verification.token-timeout-failure': {
    id: 'shared.email-verification.token-timeout-failure',
    defaultMessage: 'That code has expired. Please check your email for a new code.',
  },
  'shared.almost-there': {
    id: 'shared.almost-there',
    defaultMessage: 'Almost There...',
  },
  'shared.email-verification': {
    id: 'shared.email-verification',
    defaultMessage: 'Email verification',
  },
  'shared.connect-to-google': {
    id: 'shared.connect-to-google',
    defaultMessage: 'Connect to Google',
    description: 'Link text for connecting to Google social account',
  },
  'shared.connect-to-facebook': {
    id: 'shared.connect-to-facebook',
    defaultMessage: 'Connect to Facebook',
    description: 'Link text for connecting to Facebook social account',
  },
  'shared.connect-to-linkedin': {
    id: 'shared.connect-to-linkedin',
    defaultMessage: 'Connect to LinkedIn',
    description: 'Link text for connecting to LinkedIn social account',
  },
  'shared.connect-to-microsoft': {
    id: 'shared.connect-to-microsoft',
    defaultMessage: 'Connect to Microsoft',
    description: 'Link text for connecting to Microsoft social account',
  },
  'shared.connect-to-lastpass': {
    id: 'shared.connect-to-lastpass',
    defaultMessage: 'Connect to LastPass',
    description: 'Link text for connecting to LastPass social account',
  },
  'shared.connect-to-apple': {
    id: 'shared.connect-to-apple',
    defaultMessage: 'Connect to Apple',
    description: 'Link text for connecting to Apple social account',
  },
  'shared.or': {
    id: 'shared.or',
    defaultMessage: 'or',
    description: 'Word OR to separate two available actions.',
  },
  'shared.select.prompt': {
    id: 'shared.select.prompt',
    defaultMessage: 'Select...',
    description: 'Used as a prompt text in select dropdown lists to prompt the user to make a selection',
  },
  'shared.personal.info': {
    id: 'shared.personal.info',
    defaultMessage: 'Personal info',
    description: 'Section title for the personal info fields and navbar link',
  },
  'shared.profile.picture': {
    id: 'shared.profile.picture',
    defaultMessage: 'Profile picture',
    description: 'Profile picture section title',
  },
  'shared.name': {
    id: 'shared.name',
    defaultMessage: 'Name',
    description: 'User name key',
  },
  'shared.signin': {
    id: 'shared.signin',
    defaultMessage: 'Sign-in',
    description: 'Heading for social account integeration',
  },

  'nav.navbar.signinsecurity': {
    id: 'nav.navbar.signinsecurity',
    defaultMessage: 'Sign-in & security',
    description: 'The nav bar Sign In & Security link',
  },
  'nav.navbar.developerTools': {
    id: 'nav.navbar.developerTools',
    defaultMessage: 'Developer tools',
    description: 'The nav bar Developer Tools link',
  },
  'shared.permissionItem.profile.title': {
    id: 'shared.permissionItem.profile.title',
    defaultMessage: 'Profile',
    description: 'Title for profile applications tile',
  },
  'shared.permissionItem.profile.subtitle': {
    id: 'shared.permissionItem.profile.subtitle',
    defaultMessage: 'For an authenticated user',
    description: 'Subtitle for profile applications tile',
  },
  'shared.permissionItem.profile.identity:read': {
    id: 'shared.permissionItem.profile.identity:read',
    defaultMessage: 'Get user information',
    description: 'Text for profile default scope',
  },
  'shared.permissionItem.profile.identity:read.cbtitle': {
    id: 'shared.permissionItem.profile.identity:read.cbtitle',
    defaultMessage: 'Get user information',
    description: 'Text for profile default scope checkbox title',
  },
  'shared.permissionItem.collaboration.title': {
    id: 'shared.permissionItem.collaboration.title',
    defaultMessage: 'GoToMeeting, GoToWebinar, or GoToTraining',
    description: 'Title for collaboration applications tile',
  },
  'shared.permissionItem.collaboration.subtitle': {
    id: 'shared.permissionItem.collaboration.subtitle',
    defaultMessage: 'To create, start, and modify sessions for remote collaboration',
    description: 'Subtitle for collaboration applications tile',
  },
  'shared.permissionItem.collaboration.cbtitle': {
    id: 'shared.permissionItem.collaboration.cbtitle',
    defaultMessage: 'GoToMeeting, GoToWebinar, GoToTraining',
    description: 'Checkbox title for collaboration applications tile',
  },
  'shared.permissionItem.support.title': {
    id: 'shared.permissionItem.support.title',
    defaultMessage: 'LogMeIn Resolve and GoToAssist Remote Support/Service Desk',
    description: 'Title for support applications tile',
  },
  'shared.permissionItem.support.subtitle': {
    id: 'shared.permissionItem.support.subtitle',
    defaultMessage: 'To create, start, and modify sessions for real-time support',
    description: 'Subtitle for support applications tile',
  },
  'shared.permissionItem.support.cbtitle': {
    id: 'shared.permissionItem.support.cbtitle',
    defaultMessage: 'LogMeIn Resolve and GoToAssist Remote Support/Service Desk',
    description: 'Checkbox title for support applications tile',
  },
  'shared.permissionItem.scim.title': {
    id: 'shared.permissionItem.scim.title',
    defaultMessage: 'SCIM',
    description: 'Title for scim applications tile',
  },
  'shared.permissionItem.scim.subtitle': {
    id: 'shared.permissionItem.scim.subtitle',
    defaultMessage: 'For automated user management',
    description: 'Subtitle for scim applications tile',
  },
  'shared.permissionItem.scim.cbtitle': {
    id: 'shared.permissionItem.scim.cbtitle',
    defaultMessage: 'SCIM',
    description: 'Checkbox title for SCIM applications tile',
  },
  'shared.permissionItem.admincenter.title': {
    id: 'shared.permissionItem.admincenter.title',
    defaultMessage: 'Admin Center',
    description: 'Title for admin center applications tile',
  },
  'shared.permissionItem.admincenter.subtitle': {
    id: 'shared.permissionItem.admincenter.subtitle',
    defaultMessage: 'To manage users across GoTo products',
    description: 'Subtitle for admin center applications tile',
  },
  'shared.permissionItem.admincenter.cbtitle': {
    id: 'shared.permissionItem.admincenter.cbtitle',
    defaultMessage: 'Admin Center',
    description: 'Subtitle for admin center applications tile',
  },
  'shared.permissionItem.jive.title': {
    id: 'shared.permissionItem.jive.title',
    defaultMessage: 'GoTo Connect',
    description: 'Title for GoToConnect applications tile',
  },
  'shared.permissionItem.jive.subtitle': {
    id: 'shared.permissionItem.jive.subtitle',
    defaultMessage: 'For initiating phone calls and other telephony services',
    description: 'Subtitle for GoToConnect applications tile',
  },
  'shared.permissionItem.jive.cbtitle': {
    id: 'shared.permissionItem.jive.cbtitle',
    defaultMessage: 'All scopes for GoTo Connect',
    description: 'Checkbox title for GoToConnect applications tile',
  },
  'shared.copy-token-id': {
    id: 'shared.copy-token-id',
    defaultMessage: 'Copy token'
  },
  'shared.copy': {
    id: 'shared.copy',
    defaultMessage: 'Copy'
  },
  'shared.enterprise-signin.enterprise-sign-in': {
    id: 'shared.enterprise-signin.enterprise-sign-in',
    defaultMessage: 'Enterprise Sign In',
    description: 'Title string for the Enterprise Sign In section',
  },
});

export default t;
